import {
    createSlice,
} from '@reduxjs/toolkit'

const initialState = {
    isSearching: false,
    fveh: [],
}

const vehicleSlice = createSlice({
    name: 'vehicles',
    initialState,
    reducers: {
        clearVehicleSearch(state, action) {
            state.isSearching = false
            state.fveh.length = 0
        },
        setVehicleSearching(state, action) {
            state.isSearching = action.payload
        },
        setVehicleSearch(state, action) {
            state.isSearching = false
            let arr = action.payload
            if (!!arr) {
                state.fveh = arr.sort((a, b) => a.rego.localeCompare(b.rego))
            } else {
                state.fveh.length = 0
            }
        },
    },
})

export const {
    setVehicleSearching, setVehicleSearch, clearVehicleSearch
    } = vehicleSlice.actions
export const vehSearching = (state) => state.vehicle.isSearching
export const vehSrchState = (state) => state.vehicle.fveh

export default vehicleSlice.reducer
